import router from '../../router'
// import Login from './Login.vue'
import Login2 from './Login2.vue'

// Setup routes
export default () => {
  router.addRoutes([
    {
      path: '/login',
      name: 'login',
      components: {
          default: Login2,
      },
      meta: {
        dontShowInMenu: true
      },
    }
  ])
}
